<template>
  <router-view />
</template>

<script>

export default {
  name: 'AgreementWrapper'
}
</script>
